import { ENV } from "../Utils";
import { User } from "../api";

const userController = new User();

export class UserPartner {
  baseApi = ENV.BASE_API;

  async createUser(accessToken, formData, userData) {
    console.log("formData", formData);
    const updatedUserData = {
      country: formData.billAddress.country, // Tomado de formData.billAddress
      address: formData.billAddress.address, // Tomado de formData.billAddress
      phone: formData.mobile, // Tomado de formData
    };

    // Si formData.fileAvatar existe, lo añadimos a updatedUserData
    if (formData.file) {
      updatedUserData.avatar = formData.file; // Añadir avatar condicionalmente
    }

    // Aquí hacemos el update del usuario con los datos combinados
    await userController.updateUser(accessToken, userData._id, updatedUserData);
    //console.log("formDataToSend", userData);

    try {
      const url = `${this.baseApi}/${ENV.API_ROUTES.CONTACT}/${userData._id}`;
      const params = {
        method: "POST",
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      };

      const response = await fetch(url, params);
      const result = await response.json();

      if (response.status !== 200) {
        throw new Error(result.message);
      }
      return result;
    } catch (error) {
      console.log(error);
    }
  }

  async getPartner(accessToken, partnerID) {
    //envolvemos todo en un try catch
    try {
      const url = `${this.baseApi}/${ENV.API_ROUTES.CONTACT}/${partnerID}`;
      const params = {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      };
      const response = await fetch(url, params);
      const result = await response.json();
      if (response.status !== 200) {
        throw new Error(result.message);
      }
      return result;
    } catch (error) {
      console.log(error);
    }
  }

  async updateUser(accessToken, idUser, userData) {
    try {
      const data = userData;

      const formData = new FormData();
      if (data.fileAvatar) {
        formData.append("avatar", data.fileAvatar);
      }
      formData.append("firstname", data.firstname);
      formData.append("lastname", data.lastname);

      // Condicional para agregar idClient solo si existe y tiene valor
      if (data.idClient) {
        formData.append("idClient", data.idClient);
      }

      formData.append("email", data.email);

      // Si hay contraseña, se incluye en el formData
      if (data.password) {
        formData.append("password", data.password);
      }

      formData.append("role", data.role);

      const url = `${ENV.BASE_API}/${ENV.API_ROUTES.USER}/${idUser}`;
      const params = {
        method: "PATCH",
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
        body: formData,
      };

      const response = await fetch(url, params);
      const result = await response.json();

      if (response.status !== 200) {
        throw new Error(result.message);
      }
      return result;
    } catch (error) {
      console.log(error);
    }
  }

  async updateUserActive(accessToken, idUser, userData) {
    try {
      const url = `${ENV.BASE_API}/${ENV.API_ROUTES.USER}/${idUser}`;
      const params = {
        method: "PATCH",
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "application/json", // Añadir el Content-Type correcto
        },
        body: JSON.stringify(userData),
      };
      const response = await fetch(url, params);
      const result = await response.json();
      if (response.status !== 200) {
        throw new Error(result.message);
      }
      return result;
    } catch (error) {
      console.log(error);
    }
  }

  async deleteUser(accessToken, idUser) {
    try {
      const url = `${this.baseApi}/${ENV.API_ROUTES.USER}/${idUser}`;
      const params = {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      };
      const response = await fetch(url, params);
      const result = await response.json();
      if (response.status !== 200) {
        throw new Error(result.message);
      }
      return result;
    } catch (error) {
      throw error;
    }
  }

  async deleteAvatar(accessToken, avatarUrl) {
    try {
      const url = `${this.baseApi}/user/delete-avatar`;
      const params = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify({ avatarUrl }),
      };
      const response = await fetch(url, params);
      const result = await response.json();
      if (response.status !== 200) {
        throw new Error(result.message);
      }
      return result;
    } catch (error) {
      console.log(error);
    }
  }
}
